/* eslint-disable react/no-direct-mutation-state */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }
  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({ [i]: false });
    });
    const dropdownPaths = [
      { path: '/apps', state: 'appsMenuOpen' },
      { path: '/admin', state: 'adminMenu' },
      { path: '/game', state: 'gameMenu' },
      { path: '/user', state: 'userMenu' },
      { path: '/agent', state: 'agentMenu' },
      { path: '/challenge', state: 'challengeMenu' },
      { path: '/transaction', state: 'transactionMenu' },
      { path: '/basic-ui', state: 'basicUiMenuOpen' },
      { path: '/form-elements', state: 'formElementsMenuOpen' },
      { path: '/tables', state: 'tablesMenuOpen' },
      { path: '/icons', state: 'iconsMenuOpen' },
      { path: '/charts', state: 'chartsMenuOpen' },
      { path: '/user-pages', state: 'userPagesMenuOpen' },
      { path: '/error-pages', state: 'errorPagesMenuOpen' },
      { path: '/Reports', state: 'reportsMenu' },
    ];
    dropdownPaths.forEach((obj => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true })
      }
    }));
  }
  render() {
    var appURL = process.env.PUBLIC_URL;
   
    
    // Injected Styles
    const styles = `
      @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
      
      .sidebar { 
        background: #fff !important; 
        font-family: 'Poppins', sans-serif; 
        box-shadow: 2px 0 20px rgba(0,0,0,0.05); 
        min-height: 100vh;
      }
      .sidebar .nav .nav-item.profile { background: #fff !important; border-bottom: 1px solid #f0f0f0; margin-bottom: 10px; }
      
      /* Nav Link General */
      .sidebar .nav .nav-item .nav-link { 
        color: #555; 
        font-weight: 500; 
        transition: 0.3s; 
        padding: 12px 20px; 
        border-radius: 0 30px 30px 0; 
        margin-right: 15px; 
        display: flex;
        align-items: center;
        background: transparent !important; 
      }
      
      .sidebar .nav .nav-item .nav-link:hover { color: #57155a; background: #f9f0fa !important; }
      
      /* Icon Fixes - Remove black backgrounds */
      .sidebar .nav .nav-item .nav-link .menu-icon { 
        color: #999; 
        background: transparent !important;
        width: auto !important;
        height: auto !important;
        line-height: 1;
        margin-right: 15px;
        font-size: 1.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0 !important;
      }
      
      /* Active State */
      .sidebar .nav .nav-item.active > .nav-link { 
        background: linear-gradient(90deg, #57155a, #8e44ad) !important; 
        color: white !important; 
        box-shadow: 0 4px 10px rgba(87, 21, 90, 0.3); 
      }
      
      .sidebar .nav .nav-item.active > .nav-link .menu-icon { color: white !important; }
      
      .sidebar .nav .nav-item .menu-title { font-size: 0.9rem; }
      
      /* Sub Menu */
      .sidebar .nav.sub-menu { background: #fff !important; padding-left: 15px; }
      .sidebar .nav.sub-menu .nav-item { margin-top: 5px; }
      .sidebar .nav.sub-menu .nav-item .nav-link { font-size: 0.85rem; padding: 10px 15px; color: #666; background: transparent !important; }
      .sidebar .nav.sub-menu .nav-item .nav-link.active { color: #57155a !important; background: transparent !important; font-weight: 700; position: relative; }
      .sidebar .nav.sub-menu .nav-item .nav-link.active:before { content: ''; position: absolute; left: 0; top: 50%; transform: translateY(-50%); width: 4px; height: 100%; background: #57155a; border-radius: 4px; }
      
      .profile-name h5 { color: #57155a; font-weight: 700 !important; }
      .menu-arrow { color: #aaa; }
      /* RESPONSIVE STYLES FOR MOBILE */
      @media (max-width: 991px) {
        .sidebar {
            position: fixed;
            top: 70px;
            bottom: 0;
            width: 260px;
            right: -260px; 
            left: auto !important; 
            transition: right 0.3s ease;
            z-index: 1000;
            background: #fff;
            display: block !important;
        }
        .sidebar.active, .sidebar-offcanvas.active {
            right: 0;
        }
      }
    `;
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <style>{styles}</style>
        
       
        
        <ul className="nav">
          <li className="nav-item profile">
            <div className="profile-desc">
              <div className="profile-pic">
                <div className="count-indicator">
                  <img 
                    className="img-xs rounded-circle" 
                    src="https://cdn-icons-png.flaticon.com/512/2206/2206368.png" 
                    alt="profile" 
                    width="35px"
                    height="35px"
                    style={{border:'2px solid #57155a', padding:'2px', objectFit:'cover'}}
                  />
                  <span className="count bg-success"></span>
                </div>
                <div className="profile-name">
                  <h5 className="mb-0 font-weight-normal"><Trans>
                     {this.props.usertype}
                  </Trans></h5>
                  <span style={{fontSize:'0.75rem', color:'#999'}}>Welcome back</span>
                </div>
              </div>
            </div>
          </li>
          
          <li className="nav-item nav-category">
            <span className="nav-link" style={{color:'#aaa', fontWeight:'600', textTransform:'uppercase', letterSpacing:'1px', fontSize:'0.75rem'}}><Trans>Navigation</Trans></span>
          </li>
          {/* Dashboard */}
          {this.props.dashboard && (
            <>
              <li className={this.isPathActive('/dashboard') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
                <Link className="nav-link" to="/dashboard">
                  <span className="menu-icon"><i className="mdi mdi-view-dashboard"></i></span>
                  <span className="menu-title"><Trans>Dashboard</Trans></span>
                </Link>
              </li>
              <li className={this.isPathActive('/real-profit') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
                <Link className="nav-link" to="/real-profit">
                  <span className="menu-icon"><i className="mdi mdi-chart-line text-success"></i></span>
                  <span className="menu-title" style={{ fontWeight: 'bold' }}><Trans>Real Profit</Trans></span>
                </Link>
              </li>
            </>
          )}
          {/* OTP Lookup */}
          <li className={this.isPathActive('/otp-lookup') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <Link className="nav-link" to="/otp-lookup">
              <span className="menu-icon"><i className="mdi mdi-message-text-outline"></i></span>
              <span className="menu-title"><Trans>OTP Lookup</Trans></span>
            </Link>
          </li>
          {/* Admin Earnings */}
          {this.props.earnings && (
            <li className={this.isPathActive('/earinigs') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
              <Link className="nav-link" to="/earinigs">
                <span className="menu-icon"><i className="mdi mdi-currency-inr"></i></span>
                <span className="menu-title"><Trans>Earnings Report</Trans></span>
              </Link>
            </li>
          )}
          {/* Admin Manager */}
          {(this.props.allAdmins || this.props.newAdmin || this.props.sitesettings) && (
            <li className={this.isPathActive('/admin') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
              <div className={this.state.adminMenu ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('adminMenu')} data-toggle="collapse">
                <span className="menu-icon"><i className="mdi mdi-shield-account"></i></span>
                <span className="menu-title"><Trans>Admin Control</Trans></span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.adminMenu}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    {this.props.allAdmins && (
                      <li className="nav-item"> <Link className={this.isPathActive('/admin/alladmins') ? 'nav-link active' : 'nav-link'} to="/admin/alladmins"><Trans>Manage Admins</Trans></Link></li>
                    )}
                    {this.props.newAdmin && (
                      <li className="nav-item"> <Link className={this.isPathActive('/admin/addadmin') ? 'nav-link active' : 'nav-link'} to="/admin/addadmin"><Trans>Add New Admin</Trans></Link></li>
                    )}
                    {this.props.allAdmins && (
                      <li className="nav-item"> <Link className={this.isPathActive('/admin/sitesettings') ? 'nav-link active' : 'nav-link'} to="/admin/sitesettings"><Trans>System Settings</Trans></Link></li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
          {/* User Manager */}
          {(this.props.allUsers || this.props.newUser || this.props.pendingKyc || this.props.completedKyc || this.props.rejectKyc) && (
            <li className={this.isPathActive('/user') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
              <div className={this.state.userMenu ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('userMenu')} data-toggle="collapse">
                <span className="menu-icon"><i className="mdi mdi-account-group"></i></span>
                <span className="menu-title"><Trans>User Management</Trans></span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.userMenu}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    {this.props.allUsers && (
                      <li className="nav-item"> <Link className={this.isPathActive('/user/allusers') ? 'nav-link active' : 'nav-link'} to="/user/allusers"><Trans>All Users</Trans></Link></li>
                    )}
                    {this.props.newUser && (
                      <li className="nav-item"> <Link className={this.isPathActive('/user/adduser') ? 'nav-link active' : 'nav-link'} to="/user/adduser"><Trans>Create User</Trans></Link></li>
                    )}
                    {this.props.pendingKyc && (
                      <li className="nav-item"> <Link className={this.isPathActive('/user/UserKyc') ? 'nav-link active' : 'nav-link'} to="/user/UserKyc"><Trans>Pending KYC</Trans></Link></li>
                    )}
                    {this.props.completedKyc && (
                      <li className="nav-item"> <Link className={this.isPathActive('/user/kyc') ? 'nav-link active' : 'nav-link'} to="/user/kyc"><Trans>Verified KYC</Trans></Link></li>
                    )}
                    {this.props.rejectKyc && (
                      <li className="nav-item"> <Link className={this.isPathActive('/user/reject') ? 'nav-link active' : 'nav-link'} to="/user/reject"><Trans>Rejected KYC</Trans></Link></li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
          {/* Challenge Manager */}
          {(this.props.allChallenges || this.props.completedChallenges || this.props.conflictChallenges || this.props.cancelledChallenges || this.props.runningChallenges || this.props.newChallenge || this.props.dropChallenge) && (
            <li className={this.isPathActive('/challenge') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
              <div className={this.state.challengeMenu ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('challengeMenu')} data-toggle="collapse">
                <span className="menu-icon"><i className="mdi mdi-gamepad-variant"></i></span>
                <span className="menu-title"><Trans>Game Challenges</Trans></span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.challengeMenu}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    <li className="nav-item"> 
                      <Link className={this.isPathActive('/challenge/pending_challange') ? 'nav-link active' : 'nav-link'} to="/challenge/pending_challange">
                        <Trans>Pending</Trans>
                      </Link>
                    </li>
                    {this.props.allChallenges && (
                      <li className="nav-item"> <Link className={this.isPathActive('/challenge/allchallenges') ? 'nav-link active' : 'nav-link'} to="/challenge/allchallenges"><Trans>All Challenges</Trans></Link></li>
                    )}
                    {this.props.runningChallenges && (
                      <li className="nav-item"> <Link className={this.isPathActive('/challenge/running_challange') ? 'nav-link active' : 'nav-link'} to="/challenge/running_challange"><Trans>Running</Trans></Link></li>
                    )}
                    {this.props.completedChallenges && (
                      <li className="nav-item"> <Link className={this.isPathActive('/challenge/result_pending') ? 'nav-link active' : 'nav-link'} to="/challenge/result_pending"><Trans>Result Pending</Trans></Link></li>
                    )}
                    {this.props.completedChallenges && (
                      <li className="nav-item"> <Link className={this.isPathActive('/challenge/completed_challange') ? 'nav-link active' : 'nav-link'} to="/challenge/completed_challange"><Trans>Completed</Trans></Link></li>
                    )}
                    {this.props.conflictChallenges && (
                      <li className="nav-item"> <Link className={this.isPathActive('/challenge/conflict_challange') ? 'nav-link active' : 'nav-link'} to="/challenge/conflict_challange"><Trans>Conflict / Review</Trans></Link></li>
                    )}
                    {this.props.cancelledChallenges && (
                      <li className="nav-item"> <Link className={this.isPathActive('/challenge/cancel_requests') ? 'nav-link active' : 'nav-link'} to="/challenge/cancel_requests"><Trans>Cancel Requests</Trans></Link></li>
                    )}
                    {this.props.cancelledChallenges && (
                      <li className="nav-item"> <Link className={this.isPathActive('/challenge/cancelled_challange') ? 'nav-link active' : 'nav-link'} to="/challenge/cancelled_challange"><Trans>Cancelled History</Trans></Link></li>
                    )}
                    {this.props.dropChallenges && (
                      <li className="nav-item"> <Link className={this.isPathActive('/challenge/drop_challange') ? 'nav-link active' : 'nav-link'} to="/challenge/drop_challange"><Trans>Dropped</Trans></Link></li>
                    )}
                    {this.props.newChallenge && (
                      <li className="nav-item"> <Link className={this.isPathActive('/challenge/new_challange') ? 'nav-link active' : 'nav-link'} to="/challenge/new_challange"><Trans>Create Challenge</Trans></Link></li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
          {/* Transaction Manager */}
          {(this.props.penaltyBonus || this.props.depositHistory || this.props.withdrawlHistory || this.props.allWithdrawlRequests || this.props.allDepositRequests) && (
            <li className={this.isPathActive('/transaction') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
              <div className={this.state.transactionMenu ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('transactionMenu')} data-toggle="collapse">
                <span className="menu-icon"><i className="mdi mdi-bank-transfer"></i></span>
                <span className="menu-title"><Trans>Transactions</Trans></span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.transactionMenu}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    {this.props.penaltyBonus && (
                      <>
                        <li className="nav-item"> <Link className={this.isPathActive('/transaction/penaltybonus') ? 'nav-link active' : 'nav-link'} to="/transaction/penaltybonus"><Trans>Penalty & Bonus</Trans></Link></li>
                        <li className="nav-item"> <Link className={this.isPathActive('/transaction/manualdeposit') ? 'nav-link active' : 'nav-link'} to="/transaction/manualdeposit"><Trans>Manual Deposit</Trans></Link></li>
                      </>
                    )}
                    {this.props.depositHistory && (
                      <li className="nav-item"> <Link className={this.isPathActive('/transaction/transaction_history') ? 'nav-link active' : 'nav-link'} to="/transaction/transaction_history"><Trans>Deposit History</Trans></Link></li>
                    )}
                    {this.props.bonusHistory && (
                      <li className="nav-item"> <Link className={this.isPathActive('/transaction/bonus_history') ? 'nav-link active' : 'nav-link'} to="/transaction/bonus_history"><Trans>Bonus History</Trans></Link></li>
                    )}
                    {this.props.bonusHistory && (
                      <li className="nav-item"> <Link className={this.isPathActive('/transaction/penalty_history') ? 'nav-link active' : 'nav-link'} to="/transaction/penalty_history"><Trans>Penalty History</Trans></Link></li>
                    )}
                    {this.props.withdrawlHistory && (
                      <li className="nav-item"> <Link className={this.isPathActive('/transaction/withdraw') ? 'nav-link active' : 'nav-link'} to="/transaction/withdraw"><Trans>Withdrawal Requests</Trans></Link></li>
                    )}
                    {this.props.allWithdrawlRequests && (
                      <li className="nav-item"> <Link className={this.isPathActive('/transaction/allwithdrawl') ? 'nav-link active' : 'nav-link'} to="/transaction/allwithdrawl"><Trans>All Withdrawals</Trans></Link></li>
                    )}
                    {this.props.allDepositRequests && (
                      <li className="nav-item"> <Link className={this.isPathActive('/transaction/alldeposits') ? 'nav-link active' : 'nav-link'} to="/transaction/alldeposits"><Trans>All Deposits</Trans></Link></li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
          {/* Reports Section */}
          {(this.props.bonusReport || this.props.depositReport || this.props.penaltyReport || this.props.withdrawlReport) && (
            <li className={this.isPathActive('/reports') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
              <div className={this.state.reportsMenu ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('reportsMenu')} data-toggle="collapse">
                <span className="menu-icon"><i className="mdi mdi-file-chart"></i></span>
                <span className="menu-title"><Trans>Reports & Analytics</Trans></span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.reportsMenu}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    {this.props.bonusReport && (
                      <li className="nav-item"> <Link className={this.isPathActive('/Reports/bonus_report') ? 'nav-link active' : 'nav-link'} to="/Reports/bonusReport"><Trans>Bonus Reports</Trans></Link></li>
                    )}
                    {this.props.depositReport && (
                      <li className="nav-item"> <Link className={this.isPathActive('/Reports/deposit_report') ? 'nav-link active' : 'nav-link'} to="/Reports/depositReport"><Trans>Deposit Reports</Trans></Link></li>
                    )}
                    {this.props.penaltyReport && (
                      <li className="nav-item"> <Link className={this.isPathActive('/Reports/penalty_report') ? 'nav-link active' : 'nav-link'} to="/Reports/penaltyReport"><Trans>Penalty Reports</Trans></Link></li>
                    )}
                    {this.props.withdrawalReport && (
                      <li className="nav-item"> <Link className={this.isPathActive('/Reports/withdrawal_report') ? 'nav-link active' : 'nav-link'} to="/Reports/withdrawalReport"><Trans>Withdrawal Reports</Trans></Link></li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
        </ul>
      </nav>
    );
  }
  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }
  componentDidMount() {
    this.onRouteChanged();
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }
}
export default withRouter(Sidebar);